import React from 'react'
import {
  List, Datagrid, TextField, EditButton, Create, SimpleForm, SelectField, SelectInput, TextInput, Edit
} from 'admin-on-rest'
import MonetaryField from '../components/monetaryField'
import AddBalanceButton from '../components/addBalanceButton'
import FederalTaxNumberField from '../components/federalTaxNumberField'

const validateOrganizations = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = ['O Nome é obrigatório!']
  }
  if (!values.email) {
    errors.email = ['O Email é obrigatório!']
  }
  if (!values.address) {
    errors.address = ['O Endereço é obrigatório!']
  }
  if (!values.number) {
    errors.number = ['O Número é obrigatório!']
  }
  if (!values.neighborhood) {
    errors.neighborhood = ['O Bairro é obrigatório!']
  }
  if (!values.postalCode) {
    errors.postalCode = ['O CEP é obrigatório!']
  }
  if (!values.city) {
    errors.city = ['A Cidade é obrigatória!']
  }
  if (!values.state) {
    errors.state = ['O Estado é obrigatório!']
  }
  if (!values.photoUrl) {
    errors.photoUrl = ['A Imagem é obrigatória!']
  }
  return errors
}

export const OrganizationList = (props) => (
  <List {...props} title='Empresas'>
    <Datagrid>
      <TextField label='Nome' source='name' />
      <TextField label='Cidade' source='city' />
      <TextField label='Estado' source='state' />
      <SelectField source='status' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <MonetaryField label='Não Distribuído' source='undistributedBalance' />
      <MonetaryField label='Saldo Total' source='totalBalance' style={{fontWeight: 'bold'}} />
      <AddBalanceButton resource='organization' />
      <EditButton />
    </Datagrid>
  </List>
)

export const OrganizationCreate = (props) => (
  <Create {...props} title='Criar Empresa'>
    <SimpleForm validate={validateOrganizations}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <FederalTaxNumberField label='CNPJ' source='federalTaxNumber' />
      <TextInput label='e-Mail' source='email' />
      <TextInput label='Imagem' source='photoUrl' options={{ fullWidth: true }} />
    </SimpleForm>
  </Create>
)

export const OrganizationEdit = (props) => (
  <Edit {...props} title='Editar Empresa'>
    <SimpleForm validate={validateOrganizations}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'},
        {id: 'deleted', name: 'Excluído'}
      ]}
      />
      <FederalTaxNumberField label='CNPJ' source='federalTaxNumber' />
      <TextInput label='e-Mail' source='email' />
      <TextInput label='Imagem' source='photoUrl' options={{ fullWidth: true }} />
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/collections/organizations.js